
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { charactersLimitRules, requiredRules } from '@/features/common/helpers/validationRules';
import { showErrorAlertDialog } from '@/features/common/helpers';
import { GlobalResponseType } from '@/features/common/types';
import { InputValidationRule } from 'vuetify';

const ADDRESS_BOOK_NICKNAME_ARIA = 'Please enter a name for this address';
const PARTS_BOOK_NICKNAME_ARIA = 'Please enter a nickname that you can refer to in the future';

@Component
export default class SaveToBook extends Vue {
  @Prop({ required: false, default: () => null }) saveCallback!: (param: unknown) => Promise<{
  item?: unknown
} & GlobalResponseType>;

  @Prop({ required: true }) value!: Record<string, unknown>;

  @Prop({ required: false, default: () => null }) validateFn!: () => boolean | Promise<boolean>;

  @Prop({ required: false }) btnClass!: string;

  @Prop({ required: false }) underlined!: boolean;

  @Prop({ required: false, default: 'addressBook' }) variant!: 'addressBook' | 'partsBook';

  private isSaving = false;

  private isSave = false;

  private nickName = '';

  private hasFieldBeenTouched = false;

  private hasAttemptedSave = false;

  private requiredRules = requiredRules;

  private charsLimitRules = charactersLimitRules(30);

  get shouldShowValidation(): boolean {
    return this.hasFieldBeenTouched || this.hasAttemptedSave;
  }

  get nickNameValidationMessage(): string {
    const rules = [this.requiredRules[0], this.charsLimitRules[0]];

    for (const rule of rules) {
      const validationRule = rule as InputValidationRule;
      const validationRuleValue = validationRule(this.nickName);
      if (validationRuleValue !== true) {
        return validationRuleValue || '';
      }
    }

    return '';
  }

  get saveLabelI18nKey(): string {
    return this.variant === 'partsBook' ? 'labels.save' : 'buttons.saveAddress';
  }

  get nicknameLabelI18nKey(): string {
    return this.variant === 'partsBook' ? 'labels.nickname' : 'labels.addressName';
  }

  get nicknameInputAriaLabel(): string {
    return this.variant === 'partsBook' ? PARTS_BOOK_NICKNAME_ARIA : ADDRESS_BOOK_NICKNAME_ARIA;
  }

  private async saveToBook() {
    if (!this.isSave) {
      this.isSave = true;
      this.hasFieldBeenTouched = false;
      this.hasAttemptedSave = false;
      return;
    }

    this.hasAttemptedSave = true;

    if (this.nickNameValidationMessage) return;
    if (this.validateFn) {
      const result = this.validateFn();
      const ok = result instanceof Promise ? await result : result;
      if (!ok) return;
    }

    this.isSaving = true;

    const response = await this.saveCallback({
      ...this.value,
      id: new Date().getTime(),
      nickname: this.nickName,
    });

    if (response && response.successful) {
      this.$emit('onSave', response.item);
      this.nickName = '';
      this.isSave = false;
      this.hasFieldBeenTouched = false;
      this.hasAttemptedSave = false;
    } else if (response && response.errorMessage) {
      showErrorAlertDialog(response.errorMessage);
    }

    this.isSaving = false;
  }

  private handleClose() {
    this.isSave = false;
    this.hasFieldBeenTouched = false;
    this.hasAttemptedSave = false;
  }
}
